import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TabVisibilityService {
  private visibilityChange$ = new Subject<'visible' | 'hidden'>();

  constructor(private zone: NgZone) {
    document.addEventListener('visibilitychange', () => {
      // NgZone.run() は、イベントが Angular のゾーン外で発生した場合でも、Angular の変更検知が実行されるようにする
      this.zone.run(() => {
        const state = document.visibilityState;
        this.visibilityChange$.next(state === 'visible' ? 'visible' : 'hidden');
      });
    });
  }

  onVisibilityChange(): Observable<'visible' | 'hidden'> {
    return this.visibilityChange$.asObservable();
  }
}
